export * from "./aws-exports";
